import Accounts from "@/services/api/Accounts";
import { stripSearchParam } from "@/utils/query";

const state = {
  roles: [],
  user: {},
  accounts: [],
  totalAccountsNumber: null,
  totalAccountsAll: null,
  accountModal: false,
  space: null,
  filterAccounts: {
    ordering: "-online",
    search: "",
    status: [],
    online: null,
    role_uuid: [],
    tags: [],
    page: 1,
    page_size: 10
  },
  totalPages: null,
  query:"ordering=-online&page_size=10&page=1"
};

const getters = {
  currentPage: state => state.filterAccounts.page,
  getRoles(state) {
    return state.roles;
  },
  getAccountUuid(state, getters, rootState){
    const spaces = state.user?.spaces || [];
    const currentSpaceUuid = rootState.global?.space || localStorage.getItem("current_space");
    const matchedSpace = spaces.find((space) => space.space_uuid === currentSpaceUuid);
    return (matchedSpace || spaces[0])?.account_uuid;
  },
  getAccountName(state){
    return state.user.display_name;
  },
  accountModal(state) {
    return state.accountModal
  },
  getFilterCheck(state){
    return state.filterAccounts;
  },
  getAccounts(state) {
    return state.accounts
  },
  getUser(state) {
    return state.user
  },
  getNumberOfAccountsPerPage(state){
    return state.filterAccounts.page_size;
  },
  getTotalAccountsNumber(state){
    return state.totalAccountsNumber;
  },
  getTotalAccountsAll(state){
    return state.totalAccountsAll;
  },
  spaceName(state) {
    if (state.space) {
      return state.space;
    } else {
      const currentSpaceUUID = localStorage.getItem("current_space");
      const space = state.user.spaces?.find(
        (space) => space.space_uuid === currentSpaceUUID
      );
      return space ? space.space_name : "Unknown Space";
    }
  },
  getPagesNumber(state){
    return state.totalPages;
  }
}

const actions = {
  toggleAccountModal({commit}) {
    commit('TOGGLE_ACCOUNT_MODAL');
  },
  inviteUsers({commit}, data) {
    return new Promise((resolve, reject) => {
      
      Accounts.inviteUsers(data).then(response => {
        commit('STATE');
        commit('SET_LOADING', false);
        
        resolve(response);
      }).catch((error) => {
        
        reject(error);
      });
    });
  },
  getAccountByUuid(uuid) {  
    const account = state.accounts.find((account) => account.uuid === uuid)
    const index = state.accounts.findIndex((account) => account.uuid === uuid)
    return {account, index}
  },
  getUser({commit, dispatch}, email) {
  return new Promise((resolve, reject) => {
    Accounts.getUser(email).then(async (response) => {
      commit('SET_USER', response.data);
      const spaces = response.data.spaces || [];
      const currentSpace = localStorage.getItem("current_space");
      const matchedSpace = spaces.find((space) => space.space_uuid === currentSpace);

      // Restore saved space when present; otherwise first available
      // (first registration / no current_space stored yet).
      const spaceToUse = matchedSpace || spaces[0];

      if (!spaceToUse) {
        reject(new Error("No spaces available for user"));
        return;
      }

      try {
        // Persist before space-account login — loginSpaceUser uses global/getSpace in the URL.
        await dispatch("global/setSpace", spaceToUse.space_uuid, { root: true });
        await Accounts.loginSpaceUser(spaceToUse.account_uuid);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    }).catch((error) => {
      reject(error);
    })
  })
},
  switchSpace({ dispatch, state }, spaceUuid) {
    const space = state.user?.spaces?.find((item) => item.space_uuid === spaceUuid);
    if (!space) {
      return Promise.reject(new Error("Space not found"));
    }

    return dispatch("global/setSpace", space.space_uuid, { root: true }).then(() =>
      Accounts.loginSpaceUser(space.account_uuid)
    );
  },
  fetchAllAccountsCount({ commit }) {
    return Accounts.getAccounts('page_size=1').then(response => {
      commit('SET_TOTAL_ACCOUNTS_ALL', response.data.objects_count);
    }).catch(err => { console.error(err); });
  },
  getAccounts({commit, state}) {
    return new Promise((resolve, reject) => {
      Accounts.getAccounts(state.query).then(response => {
        commit('SET_ACCOUNTS', response.data.accounts);
        commit('SET_TOTAL_ACCOUNTS_NUMBER', response.data.objects_count);
        commit('SET_PAGES_NUMBER', response.data.pages_count);
        if (state.totalAccountsAll === null) {
          commit('SET_TOTAL_ACCOUNTS_ALL', response.data.objects_count);
        }
        resolve(response);
      }).catch((error) => {
        
        reject(error);
      })
    })
  },
  setUser({commit}, data) {
    commit('SET_USER', data);
  },
  setQuery({commit}, data){
    commit('SET_QUERY', data);
  },
  getRoles({commit}) {
    return new Promise((resolve, reject) => {
      
      Accounts.getRoles().then(response => {
        
        commit('SET_ROLES', response.data.roles)
        resolve(response);
      }).catch(error => {
        reject(error);
        
      });
    });
  },
  setSearch({commit}, data){
    commit('SET_SEARCH', data);
  },
  // Search is not meant to outlive the accounts view: drop it from the filter
  // and from the built query so a later visit starts clean.
  clearSearch({commit, state}){
    commit('SET_SEARCH', '');
    commit('SET_QUERY', stripSearchParam(state.query));
  },
  setCheckAccountStatus({commit}, data){
    commit("SET_CHECK_ACCOUNT_STATUS", data)
  },
  setCheckRole({commit}, data){
    commit("SET_CHECK_ROLE", data)
  },
  setCheckOnline({commit}, data){
    commit("SET_CHECK_ONLINE", data)
  },
  setCheckAccountTags({commit}, data){
    commit("SET_CHECK_ACCOUNT_TAGS", data)
  },
  setPageSize({commit}, data){
    commit("SET_PAGE_SIZE", data)
  },
  setPage({commit}, data){
    commit("SET_PAGE", data)
  }
 
};
const mutations = {
  SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  TOGGLE_ACCOUNT_MODAL(state) {
    state.accountModal = !state.accountModal
  },
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts;
  },
  SET_CHECK_ACCOUNT_STATUS(state, payload){
    localStorage.setItem("checkAccountStatus", JSON.stringify(payload));
    state.filterAccounts.status = payload;
  },
  SET_CHECK_ROLE(state, payload){
    localStorage.setItem("checkRole", JSON.stringify(payload));
    state.filterAccounts.role_uuid = payload;
  },
  SET_CHECK_ONLINE(state, payload){
    localStorage.setItem("checkOnline", JSON.stringify(payload));
    state.filterAccounts.online = payload;
  },
  SET_PAGE_SIZE(state, payload){
    state.filterAccounts.page_size = payload;
  },
  SET_CHECK_ACCOUNT_TAGS(state, payload){
    localStorage.setItem("checkAccountTags", JSON.stringify(payload));
    state.filterAccounts.tags = payload;
  },
  SET_PAGE(state, payload){
    state.filterAccounts.page = payload;
  },
  SET_QUERY(state, payload){
    state.query = payload;
  },
  SET_PAGES_NUMBER(state, payload){
    state.totalPages = payload;
  },
  SET_ACCOUNTS_NUMBER(state, payload){
    state.filterAccounts.page_size = payload;
  },
  SET_TOTAL_ACCOUNTS_NUMBER(state, payload){
    state.totalAccountsNumber = payload;
  },
  SET_TOTAL_ACCOUNTS_ALL(state, payload){
    state.totalAccountsAll = payload;
  },
  SET_SEARCH(state, data){
    state.filterAccounts.search = data;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
